import { FREQS } from "./dtmf.ts";

// Tono del teclado al pulsar, como en el marcador del teléfono. Suena solo en este
// dispositivo (no se mezcla con el micrófono); lo que recibe el destino va por Connect.
let ctx: AudioContext | null = null;

export function playKeyTone(digit: string) {
  const freqs = FREQS[digit];
  if (!freqs) return;
  try {
    ctx ??= new AudioContext();
    if (ctx.state === "suspended") ctx.resume().catch(() => {});
    const start = ctx.currentTime + 0.005;
    const end = start + 0.15;
    const level = ctx.createGain();
    level.gain.setValueAtTime(0, start);
    level.gain.linearRampToValueAtTime(0.12, start + 0.005);
    level.gain.setValueAtTime(0.12, end - 0.01);
    level.gain.linearRampToValueAtTime(0, end);
    level.connect(ctx.destination);
    for (const f of freqs) {
      const osc = ctx.createOscillator();
      osc.frequency.value = f;
      osc.connect(level);
      osc.start(start);
      osc.stop(end);
    }
    setTimeout(() => level.disconnect(), 250);
  } catch { /* sin Web Audio: sin tono */ }
  // Vibración corta en móviles que la permiten.
  navigator.vibrate?.(12);
}
